import React from 'react'
import classes from './Input.module.css';

function Input(props) {
    return (
        <input className={classes.input} id={props.id} type={props.type || 'text'} value={props.value} onChange={props.onChange} onKeyDown={props.onKeyDown} autoFocus={props.autoFocus} autoComplete={props.autoComplete || 'off'} />
    )
}

export default Input;